var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 8 12"}},[_c('path',{attrs:{"d":"M0 10.59L4.59 6 0 1.41 1.41 0l6.01 6-6 6L0 10.59z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }